import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class SelectedTimeSlotActions extends Actions{
    static get target(){
        return 'selectedTimeSlot'
    }

    static clear(){
        this.set({})
    }
}


// WEBPACK FOOTER //
// ./actions/SelectedTimeSlotActions.js